export default function MerchantProductModal({
  editingProduct,
  productForm,
  inputStyle,
  setProductForm,
  onClose,
  onSubmit,
}) {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', background: 'rgba(10,18,40,0.55)', backdropFilter: 'blur(4px)' }} onClick={onClose}>
      <div style={{ background: 'white', borderRadius: '24px 24px 0 0', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 -24px 80px rgba(0,0,0,0.25)' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: '16px 0 0', display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '40px', height: '4px', borderRadius: '2px', background: '#e5e7eb' }} />
        </div>
        <div style={{ padding: '16px 24px 28px' }}>
          <div className="ui-sheet-title" style={{ fontSize: '18px', marginBottom: '20px' }}>
            {editingProduct ? 'Modifier le produit' : 'Nouveau produit'}
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Nom du produit</label>
            <input
              value={productForm.name}
              onChange={(e) => setProductForm({ ...productForm, name: e.target.value })}
              style={inputStyle}
              placeholder="Ex: Robe en wax taille M"
              onFocus={(e) => {
                e.target.style.borderColor = '#173b78';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
              }}
            />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Prix (FCFA)</label>
            <input
              value={productForm.price}
              onChange={(e) => setProductForm({ ...productForm, price: e.target.value })}
              type="number"
              style={inputStyle}
              placeholder="Ex: 15000"
              onFocus={(e) => {
                e.target.style.borderColor = '#173b78';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
              }}
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '10px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Stock (optionnel)</label>
            <input
              value={productForm.stock}
              onChange={(e) => setProductForm({ ...productForm, stock: e.target.value })}
              type="number"
              style={inputStyle}
              placeholder="Ex: 50"
              onFocus={(e) => {
                e.target.style.borderColor = '#173b78';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e2e8f0';
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={onClose}
              style={{ flex: 1, padding: '12px', borderRadius: '10px', border: '1.5px solid #e2e8f0', background: 'white', fontSize: '13px', color: '#6b7280', cursor: 'pointer', fontWeight: 500 }}
            >
              Annuler
            </button>
            <button
              onClick={onSubmit}
              style={{ flex: 2, padding: '12px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg, #c53a2d, #8b1e16)', color: 'white', fontSize: '13px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 12px rgba(197,58,45,0.3)' }}
            >
              {editingProduct ? 'Enregistrer' : 'Ajouter le produit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
